export { produtoTemChip, produtoExigeAtivacaoChip } from '../../../backend/src/services/pedido/produto-tem-chip';

/** Apresentação não migra/classifica registros históricos automaticamente. */
export function rotuloTipoChip(tipo?: string | null): string {
  const rotulos: Record<string, string> = { esim_real: 'ESIM - REAL', esim_simcard: 'ESIM - SIMCARD',
    'e-sim': 'ESIM (classificar)', fisico: 'SIMCARD (classificar)', e_sim_fisico: 'AMBOS (classificar)', aparelho: 'Aparelho', fixo: 'Fixo' };
  return tipo ? rotulos[tipo] || tipo.toUpperCase() : '';
}
